import { render, staticRenderFns } from "./moduleItem.vue?vue&type=template&id=4281eb7a&scoped=true&"
import script from "./moduleItem.vue?vue&type=script&lang=js&"
export * from "./moduleItem.vue?vue&type=script&lang=js&"
import style0 from "./moduleItem.vue?vue&type=style&index=0&id=4281eb7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281eb7a",
  null
  
)

export default component.exports